//src/Components/EmojiPicker/SelectEmojiProvider.tsx
import { ReactNode, useCallback } from 'react';
import { EmojiData } from '.';
import { SelectEmojiContext } from './contexts';

export default function SelectEmojiProvider({
  children,
  onChange,
}: {
  children: ReactNode;
  onChange: (emoji: string) => void;
}) {
  // const handles = usePopup();

  const selectEmoji = useCallback((emoji: EmojiData) => {
    onChange(emoji.skins[0].native);
    // handles?.close();
  }, []);

  return (
    <SelectEmojiContext.Provider value={{ selectEmoji }}>
      {children}
    </SelectEmojiContext.Provider>
  );
}
